import { useGetters } from 'vuex-composition-helpers'
import { computed, Ref } from 'vue'
import type { MultiselectOption } from '@ironsight/types'
import { UnitNumber } from '@/models/unit_number'

export function useResourceFilter(): { options: Ref<MultiselectOption[]> } {
  const { getVisibleUnits } = useGetters('unitNumbers', ['getVisibleUnits'])

  const options = computed<MultiselectOption[]>(() => {
    const units = Object.values(getVisibleUnits.value as Record<string, UnitNumber>)
    const unitOptions = units
      .filter((unit): unit is UnitNumber & { id: number } => unit.id != null)
      .map((unit) => ({
        label: unit.name,
        value: unit.id,
      }))

    const allOptions: MultiselectOption[] = [{ label: 'Unassigned', value: 'null' }, ...unitOptions]

    return allOptions.sort((a, b) => {
      if (a.value === 'null') return -1
      if (b.value === 'null') return 1
      return a.label.localeCompare(b.label)
    })
  })

  return { options }
}
